<template>
    <div class="container">
        <Header/>
        <FullMap
                v-if="curMap == 1 && MapData"
                title=""
                legendTop="57%"
                :areaCode="MapData.areaCode"
                :mapData="MapData.mapData"
                :legendConf="MapData.legendConf"
                :itemList="MapData.itemList"
        />
        <PointCloudmap
                    v-if="curMap == 0 && MapData"
                    :gridData="MapData.pointMapData"
                    :areaCode="MapData.areaCode"
                    :legendConf="MapData.legendConf"
                    :itemList="MapData.itemList"
            />

        <Gridmap3D v-if="curMap == 2" :gridData="MapData.gridmapData" :opacity="0.6"/>
        <Gridmap v-if="curMap == 3" :gridData="MapData.gridmapData" :opacity="0.6"/>
        <MapTitle :data="mapTitleData" @getCurTab="setCurtab"/>

        <div class="left-content">
            <BScroll>
                <div>
                    <BasePanel title="7月居民出游总览">
                        <YoukeliangGaikuang
                                :chartData="YoukeliangGaikuangData"
                                v-if="YoukeliangGaikuangData"
                        />
                    </BasePanel>

                    <BasePanel title="居民出游目的地分析-省" url="/juminchuyou/chuyoumudidifenxi">
                        <YoukeLaiyuanFenxi
                                :chartData="youkelaiyuanData"
                                v-if="youkelaiyuanData.length > 0"
                        />
                    </BasePanel>
                    <BasePanel title="居民出游热门城市TOP10">
                        <RemenChengshi/>
                    </BasePanel>
                </div>
            </BScroll>
        </div>
        <div class="right-content">
            <BScroll
            >
                <div>
                    <BasePanel code="201" title="游客群体画像">
                        <YoukeQuntiHuaxiang/>
                    </BasePanel>
                    <BasePanel code="202" title="游客行为分析">
                        <YoukeChuyouXingweiFenxi/>
                    </BasePanel>
                    <BasePanel title="游客出游热门路线" url="/juminchuyou/chuyouremenluxian">
                        <YoukeRemenLuxian
                                :chartData="youkeremenluxianData"
                                v-if="youkeremenluxianData.length > 0"
                        />
                    </BasePanel>
                </div>
            </BScroll>
        </div>
        <div
                class="center-top-content"
                :class="[{ 'click-chuantou': curMap !=0 }]"
        >
            
            
        </div>
        <div class="center-bottom-content">
            <HomeBottomBar id="homeBottomBar222"
                           :chartData="homebottombarData"
                           v-if="homebottombarData"/>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Header from "@/components/Common/Header.vue";
    import MapTitle from '@/components/Common/MapTitle.vue'
    import PointCloudmap from "@/components/JuminChuyou/PointCloudmap.vue";
    import BasePanel from "@/components/Common/BasePanel.vue";
    import YoukeliangGaikuang from "@/components/JuminChuyou/YoukeliangGaikuang.vue";
    import YoukeLaiyuanFenxi from "@/components/Home/YoukeLaiyuanFenxi.vue";
    import YoukeRemenLuxian from "@/components/Home/YoukeRemenLuxian.vue";
    // import YoukeXianshangXingweiFenxi from "@/components/Home/YoukeXianshangXingweiFenxi.vue";
    import YoukeChuyouXingweiFenxi from "@/components/JuminChuyou/YoukeChuyouXingweiFenxi.vue";
    import RemenChengshi from "@/components/JuminChuyou/ReMenChengshi.vue";

    import YoukeQuntiHuaxiang from "@/components/Home/YoukeQuntiHuaxiang.vue";
    import HomeBottomBar from "@/components/Echarts/HomeBottomBar.vue";
    import FullMap from "@/components/JuminChuyou/FullMap.vue";

    import BScroll from "@/components/Common/BScroll.vue";
    import Gridmap3D from "@/components/JuminChuyou/Gridmap.vue";
    import Gridmap from "@/components/Loca/Gridmap.vue";

    export default {
        name: "JuminChuyou",
        components: {
            Header,
            MapTitle,
            PointCloudmap,
            BasePanel,
            YoukeliangGaikuang,
            YoukeLaiyuanFenxi,
            YoukeRemenLuxian,
            // YoukeXianshangXingweiFenxi,
            YoukeChuyouXingweiFenxi,
            YoukeQuntiHuaxiang,
            RemenChengshi,
            HomeBottomBar,
            FullMap,
            BScroll,
            Gridmap3D,
            Gridmap
        },
        data() {
            return {
                  mapTitleData: {
                    title: '',
                    tab: ['点云', '普通地图', '立体散点图', '贴地散点图']
                  },
                curMap: 0,
                MapData: null,
                youkelaiyuanData: [],
                youkeremenluxianData: [],
                homebottombarData: null,
                YoukeliangGaikuangData: null,
            };
        },
        mounted() {
            this.$store.commit("setPageName", "居民出游");
            // 请求地图数据
            fetch("/data/JuminChuyou/MapData.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.MapData = json.data;
                    this.mapTitleData.title = json.data.title;
                });
            // 请求底部图表
            fetch("/data/JuminChuyou/HomeBottomBar.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.homebottombarData = json.data;
                });

            //请求游客目的地
            fetch("/data/JuminChuyou/YoukeLaiyuan.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.youkelaiyuanData = json.data;
                });

            // 请求热门路线
            fetch("/data/JuminChuyou/YoukeRemenLuxian.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.youkeremenluxianData = json.data;
                });


            // 请求游客量概况
            fetch("/data/JuminChuyou/YoukeliangGaikuang.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.YoukeliangGaikuangData = json.data;
                });


        },
  methods: {
    setCurtab(val) {
      this.curMap = val
    }
  }
    };
</script>
<style scoped lang="less">
    .center-content {
        width: 56%;
        height: 89%;
        max-height: 1080px;
        position: absolute;
        top: 1.04rem;
        left: 50%;
        transform: translateX(-50%);
        .center-top-content {
            width: 100%;
            height: 78%;
            position: relative;
        }
        .center-bottom-content {
            width: 100%;
            height: 22%;
        }
    }

    .center-top-content {
        width: 56%;
        height: 65%;
        position: relative;
        margin: 0 auto;
    }

    .center-bottom-content {
        width: 56%;
        height: 22%;
        margin: 0 auto;
    }

    .map-title {
        width: 4rem;
        height: 0.3rem;
        margin: 0.3rem auto 0;
        color: @light-blue;
        font-size: 0.2rem;
        font-weight: bold;
        position: relative;
        z-index: 9999;
        .tab {
            width: 4rem;
            height: 0.22rem;
            margin: 0.1rem auto;
            > div {
                width: 25%;
                height: 100%;
                font-size: 0.14rem;
                line-height: 0.23rem;
                color: @base-text-color;
                float: left;
                cursor: pointer;
                background: url(../assets/spot_tab_bg.png);
                background-size: 100% 100%;
            }
            .current {
                background: url(../assets/tab_bg_cur.png);
                background-size: 100% 100%;
            }
        }
    }

    .click-chuantou {
        pointer-events: none;
    }

    @media screen and (max-height: 863px) {
        .left-content {
            top: 0.84rem;
        }

        .right-content {
            top: 0.84rem;
        }

        .center-content {
            height: 90%;
            top: 0.84rem;
        }

        .center-bottom-content {
            height: 21%;
        }
    }
</style>
